import type { Section } from '../../types'
import useBuilderManager from './useBuilderManager'
import usePagesManager from './usePagesManager'
import useProfileManager from './useProfileManager'
import useSecurityCenter from './useSecurityCenter'
import useSlidesManager from './useSlidesManager'

type AdminHeadersGetter = (withJson?: boolean) => Record<string, string>

type Params = {
  token: string | null
  authHeaders: AdminHeadersGetter
  setSection: (section: Section) => void
}

export const useAdminAppManagers = ({ token, authHeaders, setSection }: Params) => {
  const slidesManager = useSlidesManager({ token, authHeaders, setSection })

  const pagesManager = usePagesManager({ token, authHeaders, setSection })

  const builderManager = useBuilderManager({
    token,
    authHeaders,
    setSection,
    loadPages: pagesManager.loadPages,
  })

  const profileManager = useProfileManager({ token, authHeaders })

  const securityManager = useSecurityCenter({ token, authHeaders })

  return {
    slidesManager,
    pagesManager,
    builderManager,
    profileManager,
    securityManager,
  }
}
